import React, { useState, useEffect } from 'react';
import { CommonCalendar } from '../../Components/Common/Calendar';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import i18n from 'i18n-js';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';

import Calendar from '../../Components/Booking/Calendar';
import AddDog from './AddDog';

let allTotalPrice = 0;
let allTotalCurrency = "";

const selectDate = async (
    value: string,
    isFromDate: boolean,
    isToDate: boolean,
    selectDate: (val: string, str: string) =>void,
    setIsFromDate: (val: boolean) => void,
    setIsToDate: (val: boolean) => void,
    dateFrom: string,
    dateTo: string,
    bookingInfoCalcDataLoading: boolean,
    solutionsSlug: string
  ) => {

  if (!bookingInfoCalcDataLoading) {
    if (isFromDate) {
      if (solutionsSlug !== 'homePrice' && value >= dateTo) {
        alert(i18n.t('invalidDateSelected'));
        return false;
      } else if (value > dateTo) {
        alert(i18n.t('invalidDateSelected'));
        return false;
      }

      await selectDate(value, 'from');
    }

    if (isToDate) {
      if (solutionsSlug !== 'homePrice' && dateFrom >= value) {
        alert(i18n.t('invalidDateSelected'));
        return false;
      } else if (dateFrom > value) {
        alert(i18n.t('invalidDateSelected'));
        return false;
      }
      await selectDate(value, 'to');
    }

    setIsFromDate(false);
    setIsToDate(false);
  }
}

const OpenModal = (props: any) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.show}
      onHide={props.onHide}
      className="box-modal-calendar"
    >
      <Modal.Body>
        <div className="box-modal-calendar-inner">
          <CommonCalendar
            userDataCalendar={props.userBookingInformation}
            getUserCalendar={props.getUserCalendar}
            selectDate={props.selectDate}
            dateFrom={props.dateFrom}
            dateTo={props.dateTo}
            isMarkDate={props.isMarkDate}
            isSameDate={props.isSameDate}
            solutionsSlug={props.solutionsSlug}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

const renderCheckBoxDogs = (setStateValue: any, arr: [], key: number, dogCount: any, bookingInfoCalc: any, dogsList: any, form: any, bookingInfoCalcDataLoading: boolean) => {
  const data: any = arr[key];

  const isChicked = dogsList.findIndex((i: any) => i.value === data.uid);

  return (
    <Form.Group key={key}>
      <Form.Check
        type="checkbox"
        label={data.name}
        checked={isChicked >= 0}
        disabled={bookingInfoCalcDataLoading}
        onChange={async (e: any) => {
          // if (!bookingInfoCalcDataLoading) {
          let newData: number = dogCount;

          const selectedVal = {
            value: data.uid,
            label: data.name,
          };

          const index = dogsList.findIndex((i: any) => i.value === selectedVal.value);

          if (index >= 0) {
            delete dogsList[index];
          } else {
            dogsList.push(selectedVal);
          }

          const newSelectedDogs = dogsList.filter((n: any) => n);

          if (e.target.checked) {
            newData = dogCount ? dogCount + 1 : 1;
          } else if (!e.target.checked) {
            newData = dogCount - 1;
          }

          await setStateValue({
            dogCount: newData,
            dogsList: newSelectedDogs,
            form: Object.assign(form, {
              dogsValue: {
                value: newSelectedDogs,
                required: true,
                errorMessage: '',
                name: 'dogsValue'
              }
            })
          });

          if (!newSelectedDogs.length) {
            await setStateValue({ bookingInfoCalcData: null });
          }

          if (newData) {
            bookingInfoCalc();
          }
          // }
        }}
      />
    </Form.Group>
  );
  // onChange={(e: any) => { setStateValue({ house: e.target.checked }) }}
}

const cancelSelectedDate = (func: any, val: string) => {
  func(val, 'bookingSpecialType')
}

const CalendarFormBooking = (props: any) => {
  const {
    confirmBooking,
    isLogin,
    userBookingInformation,
    setStateValue,
    bookingInfoCalcData,
    currentUser,
    form,
    dogForm,
    resetState,
    submitAddDog,
    bookingInfoCalc,
    dogCount,
    isSubmitAddDog,
    // currentUserLoading,
    solutionValue,
    dogsList,
  } = props;
  const [isFromDate, setIsFromDate] = useState(false);
  const [isFormAddDog, setIsFormAddDog] = useState(false);
  const [isToDate, setIsToDate] = useState(false);
  const [solutionsSlug, setSolutionsSlug] = useState(null);
  const [solutionsSpecial, setSolutionsSpecial] = useState(null);

  useEffect(() => {
    if (userBookingInformation && props.solutionValue && userBookingInformation.solutions && userBookingInformation.solutions.length) {
      for(let x=0; x < userBookingInformation.solutions.length; x++) {
        if (userBookingInformation.solutions[x].uid === props.solutionValue) {
          setSolutionsSlug(userBookingInformation.solutions[x].priceColumn);
          setSolutionsSpecial(props.bookingSpecialType.indexOf(userBookingInformation.solutions[x].priceColumn) >= 0);
          break;
        }
      }
    }
  });

  let toHide = isFromDate ? setIsFromDate : null;

  if (isToDate) {
    toHide = setIsToDate;
  }

  let isSubmit = false;

  if (bookingInfoCalcData && bookingInfoCalcData.available) {
    isSubmit = true;
  }

  if (bookingInfoCalcData && bookingInfoCalcData.length) {
    isSubmit = true;
  }

  const startDate = moment(props.dateFrom, 'YYYY-MM-DD');
  const today = moment();
  const days = props.dateFrom ? startDate.diff(today, 'days') : 0 ;

  return (
    <div className="box-form-booking">
      <p className="title">{i18n.t('bookMe')}</p>

      {
        userBookingInformation && userBookingInformation.solutions ?
          <div className="box-input-field pd-0">
            <select
              value={solutionValue}
              onChange={(e) => {
                if (!props.bookingInfoCalcDataLoading) {
                  setStateValue({ solutionValue: parseInt(e.target.value), bookingInfoCalcData: [], dateFrom: null, dateTo: null, selectedBookingDates: [] }, true)
                }
              }}
            >
              {
                userBookingInformation && userBookingInformation.solutions ?
                  userBookingInformation.solutions.map((val: {description: string, uid: number}, key: string) => {
                    return <option value={val.uid} key={key}>{val.description}</option>
                  })
                  : null
              }
            </select>

            {
              solutionsSpecial ?
                <p>{i18n.t('forBookingDatesChooseDateOnCalendar')}</p>
                : null
            }
          </div>
          :
          <div className="box-input-field">
            <select></select>
          </div>
        }

      {
        solutionsSlug === "fullDayPrice" && props.dateFrom && props.dateTo && (moment(props.dateTo, 'YYYY-MM-DD').diff(moment(props.dateFrom, 'YYYY-MM-DD'), 'days') <= 1) ?
          <Form.Group>
            <Form.Check
              type="checkbox"
              label={i18n.t('careLessthan24hrs')}
              className="lessThan24hr"
              onChange={async (e: any) => {
                if (!props.bookingInfoCalcDataLoading) {
                  setStateValue({ lessThan24hr: e.target.checked }, true)
                }
              }}
            />
          </Form.Group>
          : null
      }

      {
        // <div className="box-input-field">
        //   <select onChange={(e) => { setStateValue({ dogCount: parseInt(e.target.value) }, true) }}>
        //     <option value="1">1 hund</option>
        //     <option value="2">2 hund</option>
        //     <option value="3">3 hund</option>
        //     <option value="4">4 hund</option>
        //     <option value="5">5 hund</option>
        //   </select>
        // </div>
      }

      <div className="box-dog-list">
        {
          currentUser ?
            <div className="box-dog-list-inner pd-top-20">
              {
                currentUser.dogs && currentUser.dogs.length ?
                  Object.keys(currentUser.dogs).map((key: string) => renderCheckBoxDogs(setStateValue, currentUser.dogs, parseInt(key, 10), dogCount, bookingInfoCalc, dogsList, form, props.bookingInfoCalcDataLoading ))
                  :
                  <p className="note-text">{i18n.t('pleaseAddDogeBeforeBook')}</p>
              }
              <div className="box-btn">
                {
                  isFormAddDog ?
                    <Modal
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      show={isFormAddDog}
                      onHide={() => setIsFormAddDog(false)}
                      className="box-modal-add-dog"
                    >
                      <Modal.Body>
                        <div className="box-modal-add-dog-inner">
                          <AddDog
                            isSubmitAddDog={isSubmitAddDog}
                            setStateValue={setStateValue}
                            form={form}
                            dogForm={dogForm}
                            submitAddDog={submitAddDog}
                            setIsFormAddDog={setIsFormAddDog}
                          />
                        </div>
                      </Modal.Body>
                    </Modal>
                    : null
                }
                {
                  currentUser ?
                    <button className="green" onClick={() => {
                      setIsFormAddDog(true)
                      resetState()
                    }}>
                      {i18n.t('addDog')}
                    </button>
                    : null
                }
              </div>
            </div>
            : null
        }
        {
          // !currentUser && !currentUserLoading ?
          //  <p className="not-login">User not login</p>
          //  : null
        }
      </div>

      <Calendar {...props} solutionsSpecial={solutionsSpecial} solutionsSlug={solutionsSlug} />

      {
        solutionsSpecial === false ?
          <div className="box-input-calendar">
            <input
              className="input-calendar"
              type="text"
              readOnly
              value={props.dateFrom ? moment(props.dateFrom, 'YYYY-MM-DD').format('DD-MM-YYYY') : i18n.t('startDate')}
              onClick={()=> {
                if (!props.dateFrom) {
                  const currentDate = moment().format('YYYY-MM-DD');
                  props.getUserCalendar2(currentDate, currentDate);
                }

                setIsFromDate(true)
              }}
            />
            <input
              className="input-calendar"
              type="text"
              readOnly
              value={props.dateTo ? moment(props.dateTo, 'YYYY-MM-DD').format('DD-MM-YYYY') : i18n.t('endDate') }
              onClick={() => {
                const currentDate = moment().format('YYYY-MM-DD');
                props.getUserCalendar2(currentDate, currentDate);
                setIsToDate(true)
              }}
            />
          </div>
          : null
      }

      <OpenModal
        show={isFromDate || isToDate}
        onHide={() => toHide ? toHide(false) : null }
        dateFrom={props.dateFrom}
        dateTo={props.dateTo}
        selectDate={(value: any) => {
          selectDate(value, isFromDate, isToDate, props.selectDate, setIsFromDate, setIsToDate, props.dateFrom, props.dateTo, props.bookingInfoCalcDataLoading, solutionsSlug);
        }}
        isMarkDate={isToDate}
        isSameDate={solutionsSlug === 'homePrice' ? true : false}
        userBookingInformation={props.userCalendar2}
        getUserCalendar={props.getUserCalendar2}
        solutionsSlug={solutionsSlug}
      />
      {
        bookingInfoCalcData && bookingInfoCalcData.available ?

          <div>
            <p className="subtotal">{i18n.t('dinPris')}</p>
            <table>
                <tr>
                    <td>{bookingInfoCalcData.bookingType}</td>
                    <td>{bookingInfoCalcData.currency} {(Math.round(bookingInfoCalcData.price * 100) / 100).toFixed(2).replace(".", ",")}</td>
                </tr>
                <tr>
                    <td>
                        <u data-tip={i18n.t('bookingFeeExplanation')}>{i18n.t('serviceFee')}</u>
                        <ReactTooltip effect="solid" place="top" />
                    </td>
                    <td>{bookingInfoCalcData.currency} {(Math.round(bookingInfoCalcData.bookingFee * 100) / 100).toFixed(2).replace(".", ",")}</td>
                </tr>
                <tr>
                    <td><b>{i18n.t('total')}</b></td>
                    <td><b>{bookingInfoCalcData.currency} {(Math.round(bookingInfoCalcData.totalPrice * 100) / 100).toFixed(2).replace(".", ",")}</b></td>
                </tr>
            </table>
          </div>
          : null
      }
      {
        bookingInfoCalcData && bookingInfoCalcData.length ?
          <div className="overflow-hidden">
            <p className="subtotal">{i18n.t('dinPris')}</p>
              {
                bookingInfoCalcData.map((data: any, key: any) => {
                    if(key === 0){
                        allTotalPrice = 0;
                    }
                    allTotalPrice += parseFloat(data.totalPrice);
                    allTotalCurrency = data.currency;

                    return (
                      <div className="line-this" key={key}>
                        <table>
                            <tr>
                                <th>{moment(data.fromdate, 'YYYY-MM-DD').format('DD-MM-YYYY')}</th>
                                <th>
                                    <span className="to-right btn-close" onClick={() => {
                                            if (solutionsSpecial) {
                                              cancelSelectedDate(props.selectDate, data.fromdate)
                                            }
                                          }}
                                    >
                                        ×
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <td>{data.bookingType}</td>
                                <td>{data.currency} {(Math.round(data.price * 100) / 100).toFixed(2).replace(".", ",")}</td>
                            </tr>
                            <tr>
                                <td>
                                    <u data-tip={i18n.t('bookingFeeExplanation')}>{i18n.t('serviceFee')}</u>
                                    <ReactTooltip effect="solid" place="top" />
                                </td>
                                <td>{data.currency} {(Math.round(data.bookingFee * 100) / 100).toFixed(2).replace(".", ",")}</td>
                            </tr>
                        </table>
                      </div>
                    )
                })
              }
              <span className="to-left"><b>{i18n.t('total')}</b></span>
              <span className="to-right"><b>{allTotalCurrency} {(Math.round(allTotalPrice * 100) / 100).toFixed(2).replace(".", ",")}</b></span>
          </div>
          : null
      }
      {
        (!props.currentUserLoading && !currentUser) || (!props.currentUserLoading && currentUser && String(currentUser.uid) !== String(props.dogsitterId)) ?
          <div className="box-btn">
            {
                isLogin ?
                    <button className="green" onClick={() => confirmBooking()}>
                        {isSubmit ? i18n.t('bookNow') : i18n.t('bookAttention')}
                    </button>
                :
                    <a href="#" data-toggle="modal" data-target="#signin_form" className="nav-link green">
                        {i18n.t('bookAttention')}
                    </a>
            }
            {
              solutionsSpecial === false && days > 7 ?
                <small className="text-white text-center d-block">
                    {i18n.t('cancelationPolicy')}
                </small>
              : null
            }
          </div>
          : null
      }
    </div>
  )
}

export default CalendarFormBooking;
